
@let loading = isVisualValid() && ((!data.loaded() && !data.failure()) || ag.resetAg());

<div class="pivot-table-visual-container" [class.loading]="loading">
  @if (canRender()) {
  @if (showRowCount()) {
    @let rc = rowCount();
    <div class="visual__row-count">
      <span class="mr-4">Total Rows:</span>
      @if (rc.loaded) {
        <span>{{rc.rowCount}}</span>
      }
      @else {
        <loading-rect size="35px 12px"></loading-rect>
      }
    </div>
  }
    <div class="ag-grid-table-container pivot-table-visual"
         [class.has-grand-total]="hasGrandTotal()"
         [class.ag-grid-has-selection]="hasSelection()"
         [class.ag-grid-cell-navigation]="cellNavigationStarted()"
         [class.first-data-rendered]="ag.firstDataRendered()"
         [class.ag-grid-columns-only-pivot]="columnOnlyDisplay()">
      @if (ag.canInit()) {
        <ag-grid-angular #agGrid
                         class="ag-grid-table ag-grid-table-data pivot-table-visual__ag-grid"
                         [class.has-columns]="hasColumns()"
                         [gridOptions]="ag.gridOptions()"
                         [theme]="ag.theme()"
                         [getRowHeight]="ag.getRowHeight"
                         [rowModelType]="'serverSide'"
                         [serverSideDatasource]="ag.source()?.serverSideDatasourceAdapter()"
                         [defaultColDef]="ag.defaultColDef"
                         [columnDefs]="ag.columnDefs()"
                         [autoGroupColumnDef]="ag.autoGroupColumnDef()"
                         [getRowId]="ag.getRowId"
                         [getMainMenuItems]="ag.getMainMenuItems"
                         [getContextMenuItems]="ag.getContextMenuItems"
                         (gridPreDestroyed)="ag.gridReadyState.set(false)"
                         (gridReady)="ag.gridReadyState.set(true)"
                         (firstDataRendered)="ag.firstDataRenderedState.set(true)"
                         (sortChanged)="ag.onGridSortChanged($event)"
                         (columnMoved)="ag.onGridColumnMoved($event)"
                         (columnResized)="onAgGridColumnResized($event)"

                         (selectionChanged)     ="onAgGridSelectionChanged($event)"
                         (cellSelectionChanged) ="onAgGridCellSelectionChanged($event)"
                         (rangeSelectionChanged)="onAgGridSelectionChanged($event)"
                         (rowSelected)          ="onAgGridRowSelected($event)"

                         (cellKeyDown)="ag.onGridCellKeyDown($event)"
                         (rowGroupOpened)="ag.onRowGroupOpened($event)"
                         (modelUpdated)="ag.onDataLoaded($event)">
        </ag-grid-angular>
      }
    </div>
  }

  @if (loading) {
    <div class="pivot-table-visual-loading-overlay">
      <app-spinner></app-spinner>
    </div>
  }
</div>

<div class="pivot-table-column-header-menu-trigger" [matMenuTriggerFor]="columnHeaderMenu"
     #columnHeaderMenuTriggerElement
     #columnHeaderMenuTrigger="matMenuTrigger">
</div>

<mat-menu #columnHeaderMenu="matMenu">
  <ng-template matMenuContent>
    <button mat-menu-item (click)="columnHeaderSetSort(SortDirection.Ascending)" [hidden]="columnHeaderSort() == SortDirection.Ascending">
      <div class="d-flex justify-content-between align-items-center">
        <span>Sort Ascending</span>
        <i class="far fa-arrow-up"></i>
      </div>
    </button>
    <button mat-menu-item (click)="columnHeaderSetSort(SortDirection.Descending)" [hidden]="columnHeaderSort() == SortDirection.Descending">
      <div class="d-flex justify-content-between align-items-center">
        <span>Sort Descending</span>
        <i class="far fa-arrow-down"></i>
      </div>
    </button>
    <button mat-menu-item (click)="columnHeaderClearSort()" [hidden]="!columnHeaderSort()">
      <div class="d-flex justify-content-between align-items-center">
        <span>Clear Sort</span>
      </div>
    </button>

    <div class="ag-menu-separator" style="display: block"></div>

    <button mat-menu-item (click)="columnHeaderAutoSizeColumn()">
      <div class="d-flex justify-content-between align-items-center">
        <span>Autosize This Column</span>
      </div>
    </button>
    <button mat-menu-item (click)="columnHeaderAutoSizeAllColumns()">
      <div class="d-flex justify-content-between align-items-center">
        <span>Autosize All Column</span>
      </div>
    </button>
  </ng-template>
</mat-menu>